import { render, staticRenderFns } from "./FabricKnitTypeCreateEdit.vue?vue&type=template&id=0eb9eb14&scoped=true&"
import script from "./FabricKnitTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./FabricKnitTypeCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb9eb14",
  null
  
)

export default component.exports